// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ALBUM_DESCRIPTION_SHOW_MORE = "Zobraz viac";
export const LIKE_BUTTON_LABEL = "P\u00e1\u010di sa mi";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
